module.exports = __webpack_public_path__ + "media/images/common/lp/bg-presentAmazon-left-6395f1c86567318d3f386b3a229087de.png";